module.exports = __webpack_public_path__ + "static/media/Gucci-Metallic-Princeton-Slide-Loafers-Lyst.48fc4355.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/shoes/Gucci-Metallic-Princeton-Slide-Loafers-Lyst.png
// module id = 275
// module chunks = 0